import "antd/es/form/style";
import _Form from "antd/es/form";
import "antd/es/config-provider/style";
import _ConfigProvider from "antd/es/config-provider";
import "antd/es/button/style";
import _Button from "antd/es/button";
import _extends from "@babel/runtime/helpers/esm/extends";
import "antd/es/tooltip/style";
import _Tooltip from "antd/es/tooltip";
import "antd/es/spin/style";
import _Spin from "antd/es/spin";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["creatorButtonProps", "deleteIconProps", "copyIconProps", "itemContainerRender", "itemRender", "prefixCls", "creatorRecord", "action", "actionGuard", "children", "actionRender", "fields", "meta", "field", "index", "formInstance", "alwaysShowItemLabel", "min", "max", "count"],
    _excluded2 = ["actionRender", "creatorButtonProps", "label", "alwaysShowItemLabel", "tooltip", "creatorRecord", "itemRender", "rules", "itemContainerRender", "copyIconProps", "children", "deleteIconProps", "actionRef", "style", "prefixCls", "actionGuard", "min", "max"];
import { CopyOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { nanoid, runFunction, ProFormContext } from '@ant-design/pro-utils';
import omit from 'omit.js';
import toArray from "rc-util/es/Children/toArray";
import { useEffect, useState } from 'react';
import React, { useContext, useImperativeHandle, useMemo, useRef } from 'react';
import './index.less';
import { noteOnce } from "rc-util/es/warning";
var FormListContext = /*#__PURE__*/React.createContext({});
/** Antd 自带的toArray 不这次方法，所以需要自己搞一个 */

var listToArray = function listToArray(children) {
  if (Array.isArray(children)) {
    return children;
  }

  if (typeof children === 'function') {
    return [children];
  }

  return toArray(children);
};

var ProFormListItem = function ProFormListItem(props) {
  var _formInstance$getFiel;

  var creatorButtonProps = props.creatorButtonProps,
      deleteIconProps = props.deleteIconProps,
      copyIconProps = props.copyIconProps,
      itemContainerRender = props.itemContainerRender,
      itemRender = props.itemRender,
      prefixCls = props.prefixCls,
      creatorRecord = props.creatorRecord,
      action = props.action,
      actionGuard = props.actionGuard,
      children = props.children,
      actionRender = props.actionRender,
      fields = props.fields,
      meta = props.meta,
      field = props.field,
      index = props.index,
      formInstance = props.formInstance,
      alwaysShowItemLabel = props.alwaysShowItemLabel,
      min = props.min,
      max = props.max,
      count = props.count,
      rest = _objectWithoutProperties(props, _excluded);

  var listContext = useContext(FormListContext);
  var unmountedRef = useRef(false);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loadingRemove = _useState2[0],
      setLoadingRemove = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loadingCopy = _useState4[0],
      setLoadingCopy = _useState4[1];

  useEffect(function () {
    return function () {
      unmountedRef.current = true;
    };
  }, []);
  var childrenArray = listToArray(children).map(function (childrenItem) {
    if (typeof childrenItem === 'function') {
      return childrenItem === null || childrenItem === void 0 ? void 0 : childrenItem(field, index, action);
    }

    return childrenItem;
  }).map(function (childrenItem, itemIndex) {
    if ( /*#__PURE__*/React.isValidElement(childrenItem)) {
      var _childrenItem$props, _childrenItem$type, _childrenItem$props2;

      var hasKey = !!childrenItem.key || !!(childrenItem === null || childrenItem === void 0 ? void 0 : (_childrenItem$props = childrenItem.props) === null || _childrenItem$props === void 0 ? void 0 : _childrenItem$props.name) || (childrenItem === null || childrenItem === void 0 ? void 0 : (_childrenItem$type = childrenItem.type) === null || _childrenItem$type === void 0 ? void 0 : _childrenItem$type.toString()) === 'Symbol(react.fragment)';
      noteOnce(hasKey, 'ProFormList 的 children 不设置 key 可能导致更新不及时或者修改不生效的问题，请设置 key。');
      noteOnce(hasKey, "ProFormList's children do not set the key may cause updates not to be timely or the modification does not take effect, please set the key.");
      return /*#__PURE__*/React.cloneElement(childrenItem, _objectSpread({
        key: childrenItem.key || (childrenItem === null || childrenItem === void 0 ? void 0 : (_childrenItem$props2 = childrenItem.props) === null || _childrenItem$props2 === void 0 ? void 0 : _childrenItem$props2.name) || itemIndex
      }, childrenItem === null || childrenItem === void 0 ? void 0 : childrenItem.props));
    }

    return childrenItem;
  });
  var copyIcon = useMemo(function () {
    /** 复制按钮的配置 */
    if (!copyIconProps || max === count) return null;
    var _copyIconProps$Icon = copyIconProps.Icon,
        Icon = _copyIconProps$Icon === void 0 ? CopyOutlined : _copyIconProps$Icon,
        tooltipText = copyIconProps.tooltipText;
    return /*#__PURE__*/React.createElement(_Tooltip, {
      title: tooltipText,
      key: "copy"
    }, /*#__PURE__*/React.createElement(_Spin, {
      spinning: loadingCopy
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "".concat(prefixCls, "-action-icon action-copy"),
      onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setLoadingCopy(true);
                _context.next = 3;
                return action.add(formInstance === null || formInstance === void 0 ? void 0 : formInstance.getFieldValue([listContext.listName, rest.name, field.name].filter(function (item) {
                  return item !== undefined;
                }).flat(1)));

              case 3:
                setLoadingCopy(false);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))
    })));
  }, [copyIconProps, max, count, loadingCopy, prefixCls, action, formInstance, listContext.listName, rest.name, field.name]);
  var deleteIcon = useMemo(function () {
    if (!deleteIconProps || min === count) return null;
    var _deleteIconProps$Icon = deleteIconProps.Icon,
        Icon = _deleteIconProps$Icon === void 0 ? DeleteOutlined : _deleteIconProps$Icon,
        tooltipText = deleteIconProps.tooltipText;
    return /*#__PURE__*/React.createElement(_Tooltip, {
      title: tooltipText,
      key: "delete"
    }, /*#__PURE__*/React.createElement(_Spin, {
      spinning: loadingRemove
    }, /*#__PURE__*/React.createElement(Icon, {
      className: "".concat(prefixCls, "-action-icon action-remove"),
      onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setLoadingRemove(true);
                _context2.next = 3;
                return action.remove(field.name);

              case 3:
                if (!unmountedRef.current) {
                  setLoadingRemove(false);
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))
    })));
  }, [deleteIconProps, min, count, loadingRemove, prefixCls, setLoadingRemove, action, field.name]);
  var defaultActionDom = useMemo(function () {
    return [copyIcon, deleteIcon].filter(Boolean);
  }, [copyIcon, deleteIcon]);
  var actions = (actionRender === null || actionRender === void 0 ? void 0 : actionRender(field, action, defaultActionDom, count)) || defaultActionDom;
  var dom = actions.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-action")
  }, actions) : null;
  var options = {
    name: rest.name,
    field: field,
    index: index,
    record: formInstance === null || formInstance === void 0 ? void 0 : (_formInstance$getFiel = formInstance.getFieldValue) === null || _formInstance$getFiel === void 0 ? void 0 : _formInstance$getFiel.call(formInstance, [listContext.listName, rest.name, field.name].filter(function (item) {
      return item !== undefined;
    }).flat(1)),
    fields: fields,
    operation: action,
    meta: meta
  };
  var itemContainer = (itemContainerRender === null || itemContainerRender === void 0 ? void 0 : itemContainerRender(childrenArray, options)) || childrenArray;
  var contentDom = (itemRender === null || itemRender === void 0 ? void 0 : itemRender({
    listDom: /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-container")
    }, itemContainer),
    action: dom
  }, options)) || /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-item").concat(alwaysShowItemLabel ? " ".concat(prefixCls, "-item-show-label") : ''),
    style: {
      display: 'flex',
      alignItems: 'flex-end'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-container")
  }, itemContainer), dom);
  return /*#__PURE__*/React.createElement(FormListContext.Provider, {
    key: field.name,
    value: _objectSpread(_objectSpread({}, field), {}, {
      listName: [listContext.listName, rest.originName, field.name].filter(function (item) {
        return item !== undefined;
      }).flat(1)
    })
  }, contentDom);
};

var ProFormListContainer = function ProFormListContainer(props) {
  var creatorButtonProps = props.creatorButtonProps,
      prefixCls = props.prefixCls,
      children = props.children,
      creatorRecord = props.creatorRecord,
      action = props.action,
      fields = props.fields,
      actionGuard = props.actionGuard,
      max = props.max;
  var fieldKeyMap = useRef(new Map());

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var uuidFields = useMemo(function () {
    return fields.map(function (field) {
      var _fieldKeyMap$current, _fieldKeyMap$current3;

      if (!((_fieldKeyMap$current = fieldKeyMap.current) === null || _fieldKeyMap$current === void 0 ? void 0 : _fieldKeyMap$current.has(field.key.toString()))) {
        var _fieldKeyMap$current2;

        (_fieldKeyMap$current2 = fieldKeyMap.current) === null || _fieldKeyMap$current2 === void 0 ? void 0 : _fieldKeyMap$current2.set(field.key.toString(), nanoid());
      }

      var uuid = (_fieldKeyMap$current3 = fieldKeyMap.current) === null || _fieldKeyMap$current3 === void 0 ? void 0 : _fieldKeyMap$current3.get(field.key.toString());
      return _objectSpread(_objectSpread({}, field), {}, {
        uuid: uuid
      });
    });
  }, [fields]);
  /**
   * 根据行为守卫包装action函数
   */

  var wrapperAction = useMemo(function () {
    var wrapAction = _objectSpread({}, action);

    var count = uuidFields.length;

    if (actionGuard === null || actionGuard === void 0 ? void 0 : actionGuard.beforeAddRow) {
      wrapAction.add = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _len,
            rest,
            _key,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                for (_len = _args3.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
                  rest[_key] = _args3[_key];
                }

                _context3.next = 3;
                return actionGuard.beforeAddRow.apply(actionGuard, rest.concat([count]));

              case 3:
                _context3.t0 = _context3.sent;

                if (!_context3.t0) {
                  _context3.next = 6;
                  break;
                }

                _context3.t0 = action.add.apply(action, rest);

              case 6:
                return _context3.abrupt("return", _context3.t0);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }

    if (actionGuard === null || actionGuard === void 0 ? void 0 : actionGuard.beforeRemoveRow) {
      wrapAction.remove = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _len2,
            rest,
            _key2,
            _args4 = arguments;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                for (_len2 = _args4.length, rest = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                  rest[_key2] = _args4[_key2];
                }

                _context4.next = 3;
                return actionGuard.beforeRemoveRow.apply(actionGuard, rest.concat([count]));

              case 3:
                _context4.t0 = _context4.sent;

                if (!_context4.t0) {
                  _context4.next = 6;
                  break;
                }

                _context4.t0 = action.remove.apply(action, rest);

              case 6:
                return _context4.abrupt("return", _context4.t0);

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }

    return wrapAction;
  }, [action, actionGuard, uuidFields]);
  var creatorButton = useMemo(function () {
    if (creatorButtonProps === false || uuidFields.length === max) return null;

    var _ref5 = creatorButtonProps || {},
        _ref5$position = _ref5.position,
        position = _ref5$position === void 0 ? 'bottom' : _ref5$position,
        _ref5$creatorButtonTe = _ref5.creatorButtonText,
        creatorButtonText = _ref5$creatorButtonTe === void 0 ? '添加一行数据' : _ref5$creatorButtonTe;

    return /*#__PURE__*/React.createElement(_Button, _extends({
      className: "".concat(prefixCls, "-creator-button-").concat(position),
      type: "dashed",
      loading: loading,
      block: true,
      icon: /*#__PURE__*/React.createElement(PlusOutlined, null)
    }, omit(creatorButtonProps || {}, ['position', 'creatorButtonText']), {
      onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var index;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                setLoading(true); // 如果不是从顶部开始添加，则插入的索引为当前行数

                index = uuidFields.length; // 如果是顶部，加到第一个，如果不是，为空就是最后一个

                if (position === 'top') index = 0;
                _context5.next = 5;
                return wrapperAction.add(runFunction(creatorRecord), index);

              case 5:
                setLoading(false);

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))
    }), creatorButtonText);
  }, [creatorButtonProps, prefixCls, loading, wrapperAction, creatorRecord, uuidFields, max]);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: 'max-content',
      maxWidth: '100%',
      minWidth: '100%'
    }
  }, creatorButtonProps !== false && (creatorButtonProps === null || creatorButtonProps === void 0 ? void 0 : creatorButtonProps.position) === 'top' && creatorButton, uuidFields.map(function (field, index) {
    return /*#__PURE__*/React.createElement(ProFormListItem, _extends({}, props, {
      key: field.uuid,
      field: field,
      index: index,
      action: wrapperAction,
      count: uuidFields.length
    }), children);
  }), creatorButtonProps !== false && (creatorButtonProps === null || creatorButtonProps === void 0 ? void 0 : creatorButtonProps.position) !== 'top' && creatorButton);
};

var ProFormList = function ProFormList(_ref7) {
  var actionRender = _ref7.actionRender,
      creatorButtonProps = _ref7.creatorButtonProps,
      label = _ref7.label,
      alwaysShowItemLabel = _ref7.alwaysShowItemLabel,
      tooltip = _ref7.tooltip,
      creatorRecord = _ref7.creatorRecord,
      itemRender = _ref7.itemRender,
      rules = _ref7.rules,
      itemContainerRender = _ref7.itemContainerRender,
      _ref7$copyIconProps = _ref7.copyIconProps,
      copyIconProps = _ref7$copyIconProps === void 0 ? {
    Icon: CopyOutlined,
    tooltipText: '复制此行'
  } : _ref7$copyIconProps,
      children = _ref7.children,
      _ref7$deleteIconProps = _ref7.deleteIconProps,
      deleteIconProps = _ref7$deleteIconProps === void 0 ? {
    Icon: DeleteOutlined,
    tooltipText: '删除此行'
  } : _ref7$deleteIconProps,
      actionRef = _ref7.actionRef,
      style = _ref7.style,
      prefixCls = _ref7.prefixCls,
      actionGuard = _ref7.actionGuard,
      min = _ref7.min,
      max = _ref7.max,
      rest = _objectWithoutProperties(_ref7, _excluded2);

  var actionRefs = useRef();
  var context = useContext(_ConfigProvider.ConfigContext);
  var listContext = useContext(FormListContext);
  var baseClassName = context.getPrefixCls('pro-form-list'); // 处理 list 的嵌套

  var name = useMemo(function () {
    if (listContext.name === undefined) {
      return [rest.name].flat(1);
    }

    return [listContext.name, rest.name].flat(1);
  }, [listContext.name, rest.name]); // eslint-disable-next-line react-hooks/exhaustive-deps

  useImperativeHandle(actionRef, function () {
    return actionRefs.current;
  }, [actionRefs.current]);
  var proFormContext = useContext(ProFormContext);
  useEffect(function () {
    noteOnce(!!proFormContext.formRef, "ProFormList \u5FC5\u987B\u8981\u653E\u5230 ProForm \u4E2D,\u5426\u5219\u4F1A\u9020\u6210\u884C\u4E3A\u5F02\u5E38\u3002");
    noteOnce(!!proFormContext.formRef, "Proformlist must be placed in ProForm, otherwise it will cause abnormal behavior.");
  }, [proFormContext.formRef]);
  if (!proFormContext.formRef) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: baseClassName,
    style: style
  }, /*#__PURE__*/React.createElement(_Form.Item, _extends({
    label: label,
    prefixCls: prefixCls,
    tooltip: tooltip,
    style: style
  }, rest, {
    name: undefined,
    rules: undefined
  }), /*#__PURE__*/React.createElement(_Form.List, _extends({
    rules: rules
  }, rest, {
    name: name
  }), function (fields, action, meta) {
    // 将 action 暴露给外部
    actionRefs.current = action;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProFormListContainer, {
      name: name,
      originName: rest.name,
      copyIconProps: copyIconProps,
      deleteIconProps: deleteIconProps,
      formInstance: proFormContext.formRef.current,
      prefixCls: baseClassName,
      meta: meta,
      fields: fields,
      itemContainerRender: itemContainerRender,
      itemRender: itemRender,
      creatorButtonProps: creatorButtonProps,
      creatorRecord: creatorRecord,
      actionRender: actionRender,
      action: action,
      actionGuard: actionGuard,
      alwaysShowItemLabel: alwaysShowItemLabel,
      min: min,
      max: max,
      count: fields.length
    }, children), /*#__PURE__*/React.createElement(_Form.ErrorList, {
      errors: meta.errors
    }));
  })));
};

export { FormListContext };
export default ProFormList;